import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1" }, " Download a list of your electricity, gas and water assets. ")
], -1)
const _hoisted_2 = { class: "card mb-xl-1" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "d-flex overflow-auto h-20x",
  style: {"float":"right"}
}
const _hoisted_5 = { id: "container" }
const _hoisted_6 = { class: "tabs" }
const _hoisted_7 = { class: "tab" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Electricity ", -1)
const _hoisted_9 = { class: "tab" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, "Gas", -1)
const _hoisted_11 = { class: "tab" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, "Water", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  style: {},
  id: "loadingDiv"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAssetElec && _ctx.openAssetElec(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_8
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAssetGas && _ctx.openAssetGas(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_10
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAssetWater && _ctx.openAssetWater(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.elec)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_TableTab, {
            key: _ctx.tableValuesElec.length,
            "table-data": _ctx.tableValuesElec,
            "table-header": _ctx.OriginalTableHeadersElec,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnamesElec,
            pagetitle: _ctx.pageheaderElec,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.gas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_TableTab, {
            key: _ctx.tableValuesGas.length,
            "table-data": _ctx.tableValuesGas,
            "table-header": _ctx.OriginalTableHeadersGas,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnamesGas,
            pagetitle: _ctx.pageheaderGas,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.water)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_TableTab, {
            key: _ctx.tableValuesWater.length,
            "table-data": _ctx.tableValuesWater,
            "table-header": _ctx.OriginalTableHeadersWater,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnamesWater,
            pagetitle: _ctx.pageheaderWater,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true)
  ], 64))
}